export const hasSelectedRegion = (currentSelectedRegion, SelectedRegions) => {
  if (SelectedRegions && SelectedRegions.length === 0) return true;

  return SelectedRegions.find(
    (regionCode) => regionCode === currentSelectedRegion
  );
};

export const regionHasContent = (currentRegion, RegionContent) => {
  return RegionContent.find((block) => {
    return block.SelectedRegions.find(
      (regionCode) => regionCode === currentRegion
    );
  });
};
